import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { styled, AppText, Column } from '@streem/ui-react';
import { useRoomSession } from '../../../../context/room_session';
import { useObservable } from '../../../../hooks/rxjs';
export const NetworkQualitySignalText = () => {
    const roomSession = useRoomSession();
    const [remoteNetworkQuality] = useObservable(roomSession.media.remoteNetworkQuality);
    return (_jsx(NetworkSignalLevelTextContainer, { children: (remoteNetworkQuality !== null || remoteNetworkQuality !== undefined) && (_jsx(_Fragment, { children: _jsx(AppText, { as: "p", color: "grey60", semibold: true, size: "medium", style: { marginLeft: '12px', lineHeight: '21px', marginBottom: '6px' }, children: "Customer Network Strength" }) })) }));
};
const NetworkSignalLevelTextContainer = styled(Column)();
//# sourceMappingURL=network_quality_text.js.map